<template>
  <div style="height: 100%;position:relative">
    <div class="pop-header">
      <div class="header-icon" @click="returnBack()" >
        <BImg  :src="back_src" alt="back" style="padding: 0px 1px 3px 0px" v-if="!!!back" ></BImg>
      </div>
      <div class="pop-headertitle">
        {{$t("popenvironment.title")}}
      </div>
    </div>
    <div class="main-wrapper">
      <div class="warning">
        <div>
          あなたの利用環境が、サイバックスUniv.の利用に必要な動作環境に当てはまるかどうかチェックした結果です。
        </div>
        <div>
          「プライベートブラウズモード」や「シークレットモード」ではなく、通常ブラウジングモードでご利用ください。
        </div>
        <div>
          ポップアップブロックをOFFにしてご利用ください。
        </div>
      </div>
      <div class="list">
        <div class="list-header">{{$t("popenvironment.device")}}</div>
        <div style="background-color: #E5ECF6;">{{ model.device }}</div>
        <div>
          <label>{{$t("popenvironment.os")}}</label>
          <span>
            <text style="left:15px;color: red;position:absolute;" v-if="error.os"> × </text>
            <text style="left:15px;color: grey;position:absolute;" v-else-if="model.os == 'Android'"> ー </text>
            <text style="left:15px;color: green;position:absolute;" v-else> ○ </text>
            <text>{{ model.os }}</text>
          </span>
          <div style="text-align: center;" v-if="model.os == 'Android'">
            <div>正確なOSバージョンを取得できませんでした。</div>
            <div>端末の設定からOSバージョンを確認ください。</div>
            <div>なお対応OSバージョンは12～16です。</div>
          </div>
        </div>
        <div>
          <label>{{$t("popenvironment.browser")}}</label>
          <span >
            <text style="left:15px;color: red;position:absolute;" v-if="error.browser"> × </text>
            <text style="left:15px;color: green;position:absolute;" v-else> ○ </text>
            <text>{{ model.browser }}</text>
          </span>
        </div>
        <div>
          <label>JavaScript</label>
          <span >
            <text style="left:15px;color: red;position:absolute;" v-if="error.javascriptEnabled"> × </text>
            <text style="left:15px;color: green;position:absolute;" v-else> ○ </text>
            <text>{{ model.javascriptEnabled }}</text>
          </span>
        </div>
        <div>
          <label>Cookie</label>
          <span >
            <text style="left:15px;color: red;position:absolute;" v-if="error.cookieEnabled"> × </text>
            <text style="left:15px;color: green;position:absolute;" v-else> ○ </text>
            <text>{{ model.cookieEnabled }}</text>
          </span>
        </div>
      </div>
      <div class="notices-wrapper">
          <BContainer>
              <BCard no-body img-src="" img-left body-class="card-body"  :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px;">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px;">
                      <BCardText style="word-break: keep-all;">
                      全ての項目が「○」の場合、サイバックス Univ.をご利用いただけます。
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                      <BCardText>
                      「×」が表示された場合、<a id="my-a" href="https://cybaxuniv-support2.zendesk.com/hc/ja" target="_blank">「対処方法」</a>をご確認ください。
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                      <BCardText>
                      「プライベートブラウズモード」や「シークレットモード」では受講履歴が正しく表示されない場合があります。
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                      <BCardText>
                        ポップアップブロックがONの場合、eラーニングコンテンツを正しく表示できないことがあります。
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                      <BCardText>
                      eラーニングは、スマホ対応版のみご利用いただけます。
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                    <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                    <BCardText>
                      iOS 26 では、iOS 18 と表示される場合がありますが、動作保証の範囲内です。
                    </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                    <BCardText>
                      以下のコースはAndroidに対応しておりません
                      <BCardText>
                      ・職場ケアシリーズ（LW0620〜0621）<br>
                      ・社会人なら知っておきたい　ビジネスマナー（CB01690001）<br>
                      ・SQL言語入門（NS00420003）
                     </BCardText>
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                      <BCardText>
                        2026年1月18日現在
                      </BCardText>
                  </BCardBody>
              </BCard>
              <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                  <div style="width:15px; height:20px;margin-right: 8px">
                      <BImg :src="star_src"></BImg>
                  </div>
                  <BCardBody align="start" style="padding-right: 8px">
                      <BCardText>
                      改定に伴い予告なく変更する場合があります。
                      </BCardText>
                  </BCardBody>
              </BCard>
          </BContainer>
      </div>
      <button @click="jump()" v-if="btnShowFlag">{{$t("popenvironment.confirm")}}</button>
    </div>
    <p id="footer">Copyright © 2012-{{thisYear}} Riskmonster.com All Rights Reserved.</p>
  </div>
</template>
<script>
import { useRouter, useRoute} from 'vue-router'
import { inject,onBeforeMount,onMounted,ref } from 'vue'
import UAParser from 'ua-parser-js'
import { useI18n } from 'vue-i18n'
export default {
  name: 'pop_environment',
  setup () {
    gtag('event', 'viewUsageEnvironment', {
      'event_name': 'tap'
    })
    const { t } = useI18n()
    const router = useRouter()
    const service = inject("service")
    const btnShowFlag =  ref(false)
    const error = ref({})
    var uaParser = new UAParser()
    const model = ref({})
    const back_src = require('@/assets/icon/arrow_back_envi_ios.svg')
    const thisYear=ref();
    const fromUrl = ref("");
    const eInfo = ref({})
    const route = useRoute()
    onMounted(()=>{
      let date=new Date();
      thisYear.value=date.getFullYear();
      model.value.os= uaParser.getOS().name + " "+uaParser.getOS().version
      if(
        uaParser.getOS() && uaParser.getOS().name == 'iOS' && Number(uaParser.getOS().version.split('.')[0])<16 || Number(uaParser.getOS().version.split('.')[0])>18 ||
        uaParser.getOS() && uaParser.getOS().name == 'Android' && Number(uaParser.getOS().version.split('.')[0])<10
      ){
        error.value.os = true
      }else if(!uaParser.getOS()){
        error.value.os = true
      }else{
        error.value.os = false
      }

      if (uaParser.getOS() && uaParser.getOS().name == 'Android' && Number(uaParser.getOS().version.split('.')[0]) >= 10) {
        model.value.os= uaParser.getOS().name
      }

      model.value.device = uaParser.getDevice().model
      model.value.browser = uaParser.getBrowser().name + " " + uaParser.getBrowser().version
      if(uaParser.getOS().name == 'iOS' ){
        error.value.browser = uaParser.getBrowser().name == "Mobile Safari" ? false : true
      }else if(uaParser.getOS().name == 'Android'){
        error.value.browser = uaParser.getBrowser().name == "Chrome" ? false : true
      }else{
        error.value.browser =  true
      }
      model.value.cookieEnabled = window.navigator.cookieEnabled ? t("popenvironment.avaliable") : t("popenvironment.disabled")
      error.value.cookieEnabled = window.navigator.cookieEnabled ? false : true
      model.value.javascriptEnabled = document.querySelector("noscript")?t("popenvironment.avaliable"): t("popenvironment.disabled")
      error.value.javascriptEnabled = document.querySelector("noscript")? false : true
    })

    onBeforeMount(()=>{
      if (route.params.from) {
        fromUrl.value = route.params.from
        eInfo.elearningId = route.params.elearningId
        eInfo.rank = route.params.rank
        eInfo.priceApplication = route.params.priceApplication
        eInfo.fromUrl = route.params.fromUrl

      }
      if(JSON.parse(sessionStorage.getItem("login"))){
        service.popenv.index().then((res) => {
        if(res.btnShowFlag == 1) {
            btnShowFlag.value = sessionStorage.getItem("login") ? true : false
          }else{

          }
        })
      }
    })
    function jump(){
      const login = JSON.parse(sessionStorage.getItem("login"))
      if(!login || !login.pwdChgDiv){
        router.push({ path: 'login'})
      }
      if(login.pwdChgDiv == 1) {
        router.push({ name: 'Passaiedit'})
      }else{
        router.push({ path: "/usr_top" });
      }
    }

    function returnBack () {
      if (fromUrl.value === 'elgInfo') {
        router.push({
          name: 'info',
          params: {
            elearningId: eInfo.elearningId,
            rank: eInfo.rank,
            priceApplication: eInfo.priceApplication,
            fromUrl: eInfo.fromUrl
          }
        })
      } else {
        router.go(-1)
      }
    }

    return {
      thisYear,
      jump,
      error,
      btnShowFlag,
      model,
      back_src,
      returnBack,
      star_src : require('@/assets/icon/ps.svg')
    }
  },
}
</script>

<style lang="scss" scoped>
  body{
    line-height: 1.42857143;
  }
  #my-a{
    color: var(--bs-link-color)!important;
    text-decoration: underline!important;
  }
  .pop-header{
    margin-top: 15px;
    height:52px;
    padding: 10px 0px;
    font-size: 20px;
    font-weight: bold;
    color: white;
    background-color: #376092;
  }
  .main-wrapper{
    padding: 0px 15px;
    margin: 15px auto;
    .warning{
      color: red;
      text-align: left;
      margin-bottom: 0;
      margin-top: 0;
      font-weight: 300;
      font-size: 15px;
      line-height: 20px;
    }
    .list{
      .list-header{
        background-color: #558ED5;
        color: white;
        padding: 10px;
      }
      label{
        width:100%;
        padding: 10px;
        color: #333;
        background-color: #e7e7e7;
        word-break: break-all;
      }
      span{
        padding: 2%;
        width: 100%;
        color: #333;
      }
    }
    .notices{
      text-align: left;
      margin-bottom: 0;
      margin-top: 0;
      font-weight: 300;
      font-size: 15px;
      line-height: 20px;
    }
  }
  #footer{
    font-family: "HelveticaNeue","Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 13px;
    padding: 10px 0px;
    text-align: center;
    color: #000;
    background-color: #e7e7e7;
  }
  button{
    width:100%;
    background: #2394F7;
    border-radius: 4px;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    color: #FFFFFF;
    height: 40px;
    padding: 8px 16px;
    border: none;
  }
.header-icon{
      width: 24px;
      height: 24px;
      z-index: 2;
      align-self: center;
      color: white;
    }
.pop-headertitle{
    margin-top: -24px;
  }

</style>
